import * as React from 'react';
import { createRoot } from 'react-dom/client';

// Eigene globale CSS (bisher):
import './index.css';

// NEUE Theme-Datei mit den Navy/Maize/Pink-Styles
import './theme.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

document.addEventListener('click', (e) => {
  const target = e.target as HTMLElement;
  const field = target.closest('.pa-field');
  if (field && !target.matches('input, select, textarea')) {
    const input = field.querySelector('input, select, textarea') as HTMLElement | null;
    if (input) input.focus();
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Falls du Performance messen willst:
reportWebVitals(); 